module.exports = __webpack_public_path__ + "img/xy.23d783be.svg";